var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.96 31.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #213367;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.97,10.02h0C4.92,10.02,0,14.94,0,20.99s4.92,10.97,10.97,10.97c6.05,0,10.97-4.92,10.97-10.97s-4.92-10.97-10.97-10.97ZM10.97,11.78c2.46,0,4.77.96,6.51,2.7,1.74,1.74,2.7,4.05,2.7,6.51s-.96,4.77-2.7,6.51c-1.74,1.74-4.05,2.7-6.51,2.7h0c-5.08,0-9.21-4.13-9.21-9.21,0-5.07,4.14-9.2,9.21-9.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.27,
    y: 6.02,
    width: 13.75,
    height: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.08,10.41l.8.47c.61.36,1.19.77,1.73,1.23l.07.06h8.34v-1.76s-10.94,0-10.94,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.02,14.81h-6.1l.22.38c.23.4.44.81.62,1.23l.07.15h5.19v-1.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.09,
    y: 19.39,
    width: 1.76,
    height: 6.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.09,
    y: 15.78,
    width: 1.76,
    height: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.32,0v9.56l.3-.06c.4-.08.82-.14,1.23-.18l.23-.02V1.76h20.12v23.43h-8.29l-.06.16c-.17.42-.36.83-.57,1.23l-.2.37h10.88V0H8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.69,20.72v.24s4.33,0,4.33,0v-1.76h-4.47l.04.28c.05.41.09.82.1,1.23Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.850b6070c0cf1c0460ab1c23d9bd9ba8.svg";
export { ForwardRef as ReactComponent };